module.exports = __webpack_public_path__ + "static/patricia-bc75c2a4d3ce22dbd3abf9480baf947f.png";